<template>
    <div class="modal-mask type2">
        <div class="modal-wrapper">
            <div class="modal_size sm4_size">
                <a href="javascript:" class="ui_close_type2" type="button" @click="$emit('close')">
                    <span class="sr_only"></span>
                </a>
                <dl class="modal_content">
                    <dt class="ellipsis">
                        <i>{{ $t('TITLE.POPUP.SEARCH.MODEL') }}</i>
                    </dt>
                    <dd>
                        <div class="modelSearch_wrap">
                            <div class="modelcode_wrap">
                                <dl class="request_model">
                                    <dt>{{ $t('FIELD.GLOBAL.ETC.007') }}</dt>
                                    <dd class="clearable" data-input-type="input">
                                        <input
                                            type="text"
                                            class="text_input w100p"
                                            :placeholder="$t('FIELD.GLOBAL.ETC.007')"
                                            maxlength="30"
                                            v-clearable
                                            @keyup.enter.stop="search"
                                            v-model="searchName"
                                        />
                                        <a href="javascript:" class="in_btn_search" @click="search">
                                            <i class="ico_input_serach2"></i>
                                        </a>
                                    </dd>
                                </dl>
                            </div>

                            <div class="schModel_wrap">
                                <!-- 5개줄만나오고 내부스크롤 -->
                                <table class="scroll_table_ty2">
                                    <thead class="text_left">
                                        <tr>
                                            <th width="25px"></th>
                                            <th width="90px">{{ $t('FIELD.COUNTRY.NAME') }}</th>
                                            <th width="120px">{{ $t('FIELD.SEARCH.MODELS') }}</th>
                                            <th width="190px">{{ $t('FIELD.MAJOR.PRODUCT.CATEGORY') }}</th>
                                            <th width="190px">{{ $t('FIELD.SUB.PRODUCT.CATEGORY') }}</th>
                                        </tr>
                                    </thead>
                                    <tbody class="scrollbar-inner scroll">
                                        <!-- scroll_ty2 -->
                                        <tr
                                            v-for="item in modelList"
                                            :key="'modelList' + item.NATION_CD + item.MODEL_CD"
                                        >
                                            <td width="30px" class="no_pading text_center">
                                                <label class="radiobox-wrap2">
                                                    <input
                                                        type="radio"
                                                        name="modelList"
                                                        :value="item.MODEL_CD"
                                                        @change="
                                                            modelChange(
                                                                $event,
                                                                item.NATION_CD,
                                                                item.NATION_NM,
                                                                item.MODEL_CD,
                                                                item.PRD_CATEGORY_NM1,
                                                                item.PRD_CATEGORY_NM2,
                                                            )
                                                        "
                                                    />
                                                    <i class="radio-icon"></i>
                                                </label>
                                            </td>
                                            <td width="90px" class="text_left ellipsis" :title="item.NATION_NM">
                                                {{ item.NATION_NM }}
                                            </td>
                                            <td width="120px" class="text_left ellipsis">
                                                {{ item.MODEL_CD }}
                                            </td>
                                            <td width="190px" class="text_left ellipsis">
                                                {{ item.PRD_CATEGORY_NM1 }}
                                            </td>
                                            <td width="190px" class="text_left ellipsis">
                                                {{ item.PRD_CATEGORY_NM2 }}
                                            </td>
                                        </tr>
                                        <tr v-show="0 === modelList.length">
                                            <td colspan="4">
                                                <ul class="ul_list">
                                                    <li class="nodata">
                                                        <span>{{ $t('FIELD.GLOBAL.NODATA') }}</span>
                                                    </li>
                                                </ul>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="one-btn-wrap">
                            <button class="bt-type-b" @click="$emit('close')">{{ $t('BUTTON.GLOBAL.CANCEL') }}</button>
                            <button class="bt-type-b blue" @click="save">{{ $t('BUTTON.GLOBAL.APPLY') }}</button>
                        </div>
                    </dd>
                </dl>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import { SDLUtil, StringUtil } from '@/utils';
import qs from 'query-string';
import axios from 'axios';
import constants from '@/constants';
import store from '@/vuex/store';
import scrollbar from '/static/js/jquery.scrollbar.js';

export default {
    name: 'RequestVocModelPopup',
    components: {
        scrollbar,
    },
    computed: {
        ...mapGetters({
            loginId: 'getLoginId',
            corpNo: 'getCorpNo',
            langCd: 'getLangCd',
            countryCd: 'getCountryCd',
            email: 'getEmail',
        }),
    },
    props: {
        searchModel: {
            type: String,
            default: '',
        },
        rtnFunc: {
            type: Function,
        },
    },
    data() {
        return {
            searchName: '',
            modelList: [],
            contentsList: [],
            selectCountryCd: '',
            selectCountryNm: '',
            selectModelCode: '',
            selectProductCategory: '',
        };
    },
    methods: {
        async search() {
            if (SDLUtil.textLength(this.searchName) < 10) {
                SDLUtil.alert(SDLUtil.getMsgProp('MESSAGE.TEXT.LENGTH.OVER').replace('{0}', '10'));
                return false;
            } else {
                $('input[name=modelList]').prop('checked', false);
                this.selectCountryCd = '';
                this.selectCountryNm = '';
                this.selectModelCode = '';
                this.selectProductCategory = '';
            }

            SDLUtil.showLoadingBar(true);
            return await axios
                .post(
                    `${SDLUtil.API_URL}/noauth/eur/getModelList.skp`,
                    qs.stringify({ searchName: this.searchName, locale: this.langCd }),
                )
                .then(resp => {
                    this.modelList = resp.data.result.rowData;
                    SDLUtil.showLoadingBar(false);
                })
                .catch(err => {
                    Vue.$log.error(err);
                    SDLUtil.errorAlert(err);
                    SDLUtil.showLoadingBar(false);
                });
        },
        async modelChange(e, v1, v2, v3, v4, v5) {
            this.selectCountryCd = v1;
            this.selectModelCode = v3;
            this.selectProductCategory = v2 + '/' + v4 + '/' + v5;
        },
        async save() {
            let modelCode = this.selectModelCode;
            let productCategory = this.selectProductCategory;
            let countryCd = this.selectCountryCd;
            let countryNm = this.selectCountryNm;

            const index = this.modelList.findIndex(function(item) {
                return item.NATION_CD + item.MODEL_CD === countryCd + modelCode;
            });

            let prdCategoryCd1 = this.modelList[index].PRD_CATEGORY_CD1;
            let prdCategoryCd2 = this.modelList[index].PRD_CATEGORY_CD2;
            this.rtnFunc(countryCd, modelCode, productCategory, prdCategoryCd1, prdCategoryCd2);
            this.$emit('close');
        },
    },
    mounted() {
        this.$nextTick(() => {
            $('.scrollbar-inner').scrollbar();
            this.searchName = this.searchModel;
            if (9 < SDLUtil.textLength(this.searchName)) {
                this.search();
            }
        });
    },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/skpComponents/view/basis/eur/voc/RequestVocModelPopup.vue